import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import seedrandom from "seedrandom";

const starCount = 100;
const rng = seedrandom('vivrepistoutecaounon');

export class Starfield {

  constructor(el) {
    this.$el = $(el);

    for (let i = 0; i < starCount; i++) {
      const $star = $("<div class='star'></div>");
      $("#starfield-stars", this.$el).append($star);
    }

    this.tl = this.createRepeatableTimeline();
  }

  createRepeatableTimeline() {

    const tl = gsap.timeline();

    const baseAnim = {
      yoyo: true,
      repeat: -1,
      ease: "sine.inOut"
    }

    const $stars = this.$el.find(".star");
    $stars.each((i, n) => {
      const $star = $(n);

      gsap.set($star, {
        left: rng() * 1920,
        top: rng() * 1080,
        scale: map(rng(), 0, 1, 0.2, 1)
      });

      tl.to($star, {
        y: map(rng(), 0, 1, 5, 15) * (rng() > 0.5 ? 1 : -1),
        duration: map(rng(), 0, 1, 2, 4),
        ...baseAnim
      }, 0);

      tl.to($star, {
        scale: "-=" + map(rng(), 0, 1, 0.1, 0.4),
        duration: map(rng(), 0, 1, 2, 6),
        ...baseAnim
      }, 0);
    })

    return tl;
  }

  hideFlare() {
    gsap.to(this.$el.find("#starfield-flare"), {
      autoAlpha: 0,
      duration: 0.5,
    })
  }

  hideStars(toggleValue = true) {
    gsap.to(this.$el.find("#starfield-stars"), {
      autoAlpha: (toggleValue) ? 0 : 1,
      duration: 0.5,
    })
  }

  showFlare() {
    gsap.to(this.$el.find("#starfield-flare"), {
      autoAlpha: 1,
      duration: 0.5,
    })
  }

}

